/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ListPlayerActivitySummary200ResponseResultInner } from './ListPlayerActivitySummary200ResponseResultInner';
import {
    ListPlayerActivitySummary200ResponseResultInnerFromJSON,
    ListPlayerActivitySummary200ResponseResultInnerFromJSONTyped,
    ListPlayerActivitySummary200ResponseResultInnerToJSON,
    instanceOfListPlayerActivitySummary200ResponseResultInner,
} from './ListPlayerActivitySummary200ResponseResultInner';

/**
 * 
 * @export
 * @interface ListPlayerActivitySummary200Response
 */
export interface ListPlayerActivitySummary200Response {
    /**
     * 
     * @type {Array<ListPlayerActivitySummary200ResponseResultInner>}
     * @memberof ListPlayerActivitySummary200Response
     */
    result?: Array<ListPlayerActivitySummary200ResponseResultInner>;
}


/**
 * Check if a given object implements the ListPlayerActivitySummary200Response interface.
 */
export function instanceOfListPlayerActivitySummary200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListPlayerActivitySummary200ResponseFromJSON(json: any): ListPlayerActivitySummary200Response {
    return ListPlayerActivitySummary200ResponseFromJSONTyped(json, false);
}

export function ListPlayerActivitySummary200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlayerActivitySummary200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'result': !exists(json, 'result') ? undefined : ((json['result'] as Array<any>).map(ListPlayerActivitySummary200ResponseResultInnerFromJSON)),
    };
}

export function ListPlayerActivitySummary200ResponseToJSON(value?: ListPlayerActivitySummary200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'result': value.result === undefined ? undefined : ((value.result as Array<any>).map(ListPlayerActivitySummary200ResponseResultInnerToJSON)),
    };
}

